// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "rescript/lib/es6/caml_option.js";

var IndexedDB = {};

var OpenDBRequest = {};

var DB = {};

var Transaction = {};

var ObjectStore = {};

var $$Request = {};

var $$Event = {};

var dbCache = {
  contents: undefined
};

function getDbFromEvent($$event) {
  var db = dbCache.contents;
  if (db !== undefined) {
    return Caml_option.valFromOption(db);
  }
  var target = $$event.target;
  var db$1 = target.result;
  dbCache.contents = Caml_option.some(db$1);
  return db$1;
}

function getErrorMessageFromEvent($$event) {
  try {
    return $$event["target.error"].message;
  }
  catch (exn){
    return "Unknown error occurred";
  }
}

function openDBAndGetRequest(dbName, objectStoreName) {
  var request = window.indexedDB.open(dbName, 1);
  request.onupgradeneeded = (function ($$event) {
      var db = getDbFromEvent($$event);
      db.createObjectStore(objectStoreName, {
            keyPath: "timestamp",
            autoIncrement: true
          });
    });
  return request;
}

function setupDatabase(dbName, objectStoreName, onSuccess, onError) {
  var request = openDBAndGetRequest(dbName, objectStoreName);
  request.onsuccess = (function ($$event) {
      var db = getDbFromEvent($$event);
      onSuccess(db);
    });
  request.onerror = (function ($$event) {
      var errorMessage = getErrorMessageFromEvent($$event);
      onError(errorMessage);
    });
}

function addData(db, objectStoreName, data) {
  var transaction = db.transaction([objectStoreName], "readwrite");
  var store = transaction.objectStore(objectStoreName);
  var request = store.add(data, data.timestamp);
  return [
          request,
          transaction
        ];
}

function getAllData(db, objectStoreName, onSuccess) {
  var transaction = db.transaction([objectStoreName], "readonly");
  var store = transaction.objectStore(objectStoreName);
  var request = store.getAll();
  request.onsuccess = (function (param) {
      var result = request.result;
      onSuccess(result);
    });
}

export {
  IndexedDB ,
  OpenDBRequest ,
  DB ,
  Transaction ,
  ObjectStore ,
  $$Request ,
  $$Event ,
  dbCache ,
  getDbFromEvent ,
  getErrorMessageFromEvent ,
  openDBAndGetRequest ,
  setupDatabase ,
  addData ,
  getAllData ,
}
/* No side effect */
